module.exports = __webpack_public_path__ + "static/00063.0b9b901a.jpg";